import { Image, Stack, Text, createStyles } from '@mantine/core'
import React, { memo } from 'react'
import { transitionStyles } from 'src/styles'

export interface SkillCardProps {
  skillName?: string
  skillIcon?: string
}

const useStyles = createStyles(theme => ({
  card: {
    padding: theme.spacing.sm,
    boxShadow: theme.shadows.sm,
    borderRadius: theme.radius.md,
    height: 130,
    width: 130,
    backgroundColor: theme.colorScheme === 'dark' ? '#303030' : theme.white,
    border: theme.colorScheme !== 'dark' ? '1px solid rgba(229, 231, 235, 0.7)' : 'none',
    transition: transitionStyles.themeChange,
  },
  imageStyle: {
    img: {
      maxHeight: '60px',
    },
  },
  name: {
    color: theme.colorScheme === 'dark' ? theme.colors.gray[3] : theme.colors.gray[8],
    fontSize: theme.fontSizes.md,
    fontWeight: 600,
  },
}))

export const SkillCard: React.FC<SkillCardProps> = memo(props => {
  const { skillName, skillIcon } = props
  const { classes } = useStyles()
  return (
    <Stack className={classes.card}>
      <Image src={skillIcon} fit="contain" className={classes.imageStyle} />
      <Text className={classes.name}>{skillName ?? ''}</Text>
    </Stack>
  )
})
